import React from 'react';
//import ActiveRow from '../../SeleccionCuentas/components/ActiveRow';
import Table from 'rc-table';
import { Icon } from 'react-fa';
import 'rc-table/assets/index.css';
import Dialog from 'rc-dialog';

const TipoNumeroRow = ({ tarjeta }) => {
    return (
        <div>
            <label className="label-secondary quitar-margen">{tarjeta.DescripcionProducto}</label>
            <h5 className="quitar-margen"><strong>{tarjeta.numero}</strong></h5>
        </div>
    );
}

let _removeFunc;
let _index;
let _tarjetaDeleteVisible = false;

const RemoveRow = ({ estado, index }) => {

    if (estado === 2)
        return (
            <Icon
                name="trash-o"
                size="lg"
                onClick={() => openDeleteDialog(index)}
                className="hand-pointer"
            />
        );
    else
        return null;

}

const ActiveRow = ( { estado, index } ) => {

    let estadoClass = "";
    let estadoDesc = "";
    switch ( estado ) {
        case 0:
        case 'Bloqueada':
            estadoDesc = 'BAJA';
            estadoClass = 'danger';
            break;
        case 1:
        case 'Activa':
            estadoDesc = 'ACTIVA';
            estadoClass = 'active';
            break;
        case 2:
            estadoDesc = 'NUEVA';
            estadoClass = 'new';
            break;
        case 3:
            estadoDesc = 'REIMRPESA';
            estadoClass = 'warning';
            break;

        case 'P':
        case 'p':
            estadoDesc = 'Pendiente';
            estadoClass = 'pendiente2';
            break;
        case 'E':
        case 'e':
            estadoDesc = 'Error';
            estadoClass = 'error2';
            break;
        case 'T':
        case 't':
            estadoDesc = 'En tramite';
            estadoClass = 'en-tramite2';
            break;

    }

    return (
        <div className={"div-" + estadoClass + " text-white"}>
            {estadoDesc}
        </div>
    );
}


let _removeTarjeta;

const TarjetasTable = ({ tarjetasData, solicitudes, removeTarjeta, nroCuenta, nombreCliente, productosIbs, limites }) => {
    //this.state = {
    //    tarjetaDeleteVisible: false
    //};

    const columns = [
        {
            title: 'N°',
            dataIndex: 'NumeroCuenta',
            key: 'NumeroCuenta',
            render: (value, record, index) => <p>{index + 1}</p>
        },
        {
            title: 'NOMBRE',
            dataIndex: 'Nombre',
            key: 'Nombre'
        },
        {
            title: 'TIPO DE TARJETA',
            dataIndex: 'DescripcionProducto',
            key: 'DescripcionProducto'
        },
        {
            title: 'VINCULO',
            dataIndex: '',
            key: ''
        },
        {
            title: 'LIMITE',
            dataIndex: 'LimiteDescripcion',
            key: 'LimiteDescripcion'
        },
        {
            title: ' ',
            dataIndex: 'Activo',
            key: 'Activo',
            render: (text, record) => {
                return <ActiveRow newCard={false} estado={record.Activo} isChildRow={true} />;
            }
        },
        {
            title: ' ',
            dataIndex: '',
            key: 'x',
            render: (o, row, index) => <RemoveRow estado={row.Activo} index={row.key} />
        }
    ];


    _removeFunc = removeTarjeta;

    let tarjetas = tarjetasData;
    let solicitudesFiltradas = solicitudes.filter( x => ( x.Col1 == 120002 || x.Col1 == 120001 ) && x.Estado.toLowerCase() !== 'o' && x.NumeroCuenta == nroCuenta)
    for (var i = 0; i < tarjetas.length; i++) {
        if (tarjetas[i].LimiteDescripcion.toString().indexOf("$") == -1 && tarjetas[i].Numero.toString() != "-----------------------")
            tarjetas[i].LimiteDescripcion = insertDecimalDots(tarjetas[i].LimiteDescripcion);

    }

    let tarjetasFiltradas = [];
    if ( nroCuenta !== undefined ) {
        for ( var i = 0; i < tarjetas.length; i++ ) {
            if ( tarjetas[i].NumeroCuenta == nroCuenta )
                tarjetasFiltradas.push( tarjetas[i] );
        }
        let productos = productosIbs;
        if ( solicitudesFiltradas !== undefined || solicitudesFiltradas.length > 0 ) {

            solicitudesFiltradas.forEach( function ( item ) {
                let tarjetaNew = {
                    Nombre: item.PersonaNombre + ' ' + item.PersonaApellido,
                    DescripcionProducto: productos.find( x => x.Id == item.TdProductoId ).Descripcion,
                    LimiteDescripcion: limites.find( x => x.CodigoLimite == item.Col71 ).LimiteDescripcion,
                    Activo: item.Estado,
                    idProducto: item.TdProductoId,
                    NumeroDocumento: item.Col49
                };

                tarjetasFiltradas.push( tarjetaNew );
            })

            
        }
        

    }

    return (
        <div>
            <div>
                <Table
                    columns={columns}
                    data={tarjetasFiltradas}
                    emptyText="No existen tarjetas para mostrar."
                    className="NuevaSolicitud-table"
                />
            </div>


            <div>
                <Dialog
                    visible={_tarjetaDeleteVisible}
                    onClose={() => closeDeleteDialog()}
                    animation="slide-fade"
                    maskAnimation="fade"
                    style={{ width: 400 }}
                    title="¿Desea borrar la solicitud?"
                    footer={
                        [
                            <button
                                type="button"
                                className="btn btn-default"
                                key="close"
                                onClick={() => deleteTarjeta()}
                            >
                                Aceptar
                           </button>,
                            <button
                                type="button"
                                className="btn btn-default"
                                key="cancel"
                                onClick={() => closeDeleteDialog()}
                            >
                                Cancelar
                           </button>
                        ]
                    }
                >
                    <p>
                        Está por borrar el plástico seleccionado. Aceptar para continuar.
                  </p>
                </Dialog>
            </div>
        </div>
    );

}

function deleteTarjeta() {
    _tarjetaDeleteVisible = false;
    _removeFunc(_index);
}

function closeDeleteDialog() {
    _tarjetaDeleteVisible = false;
}

function openDeleteDialog(value) {
    _index = value;
    _tarjetaDeleteVisible = true;
}

function insertDecimalDots(num) {
    var str = num.toString().split('.');
    if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.');
    }
    if (str[1] && str[1].length >= 4) {
        str[1] = str[1].replace(/(\d{3})/g, '$1 ');
    }
    return str.join('.');
}

export default TarjetasTable;
